export const formatTimeRemaining = (endTimestamp: number, startTimestamp: number): {
    days: number;
    hours: number;
    isStartDate: boolean;
} => {
    const now = Math.floor(Date.now() / 1000);

    if (now < startTimestamp) {
        const timeToStart = startTimestamp - now;
        const days = Math.floor(timeToStart / (24 * 60 * 60));
        const hours = Math.floor((timeToStart % (24 * 60 * 60)) / (60 * 60));

        return { days, hours, isStartDate: true };
    }

    const timeRemaining = endTimestamp - now;
    if (timeRemaining <= 0) {
        return { days: 0, hours: 0, isStartDate: false };
    }

    const days = Math.floor(timeRemaining / (24 * 60 * 60));
    const hours = Math.floor((timeRemaining % (24 * 60 * 60)) / (60 * 60));

    return { days, hours, isStartDate: false };
};

export const formatTimeToString = (time: { days: number; hours: number }): string => {
    if (time.days === 0 && time.hours === 0) {
        return 'Expired';
    }
    return `${time.days}d${time.hours}h`;
};

export const formatTimeString = (days: number, hours: number, isStartDate: boolean): string => {
    if (isStartDate) {
        if (days >= 30) {
            const months = Math.floor(days / 30);
            const remainingDays = days % 30;
            return `${months}m ${remainingDays}d`;
        }
        return `${days}d ${hours}h`;
    }

    return `${days}d ${hours}h`;
};


export const getTimeLeft = (date: number): number => {
    const now = new Date()
    const futureTime = new Date(date * 1000)

    const difference = futureTime.getTime() - now.getTime()
    const days: number = Math.floor(difference / (1000 * 60 * 60 * 24))

    return days
}


export const formatSecondsToMinutesSeconds = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return {
        formatted: `${minutes}m ${remainingSeconds}s`,
        totalSeconds: seconds
    };
}